const nav = [
  { value: "home", label: "home" },
  { label: "consultancy & services", value: "consultancy" },
  { value: "trainning", label: "training" },
  { value: "about", label: "about us" },
  { label: "testimonial", value: "testimonial" },
  { label: "contact", value: "contact" },
];

export default nav;
